import axios from "axios";

export const getClasss = async (id) => {
  try {
    const { data } = await axios.get(`/api/v1/class?id=${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getClasssBySession = async (sessionId) => {
  try {
    const { data } = await axios.get(
      `/api/v1/class/session?sessionId=${sessionId}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getClasssBySchoolId = async (schoolId) => {
  try {
    const { data } = await axios.get(
      `/api/v1/class/school?schoolId=${schoolId}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export const getClasssByLevel = async (levelId) => {
  try {
    const { data } = await axios.get(`/api/v1/class/level?levelId=${levelId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getClasssByGrade = async (gradeId) => {
  try {
    const { data } = await axios.get(`/api/v1/class/grade?gradeId=${gradeId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getClasssByLevelGrade = async (levelId, gradeId) => {
  try {
    const { data } = await axios.get(`/api/v1/class/${levelId}}/${gradeId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const addClass = async ({
  name,
  sessionId,
  levelId,
  gradeId,
  description,
  createdBy,
}) => {
  try {
    const { data } = await axios.post("/api/v1/class", {
      name,
      sessionId,
      levelId,
      gradeId,
      description,
      createdBy,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const editClass = async ({
  id,
  name,
  sessionId,
  levelId,
  gradeId,
  description,
  modifiedBy,
}) => {
  try {
    const { data } = await axios.patch("/api/v1/class", {
      id,
      name,
      sessionId,
      levelId,
      gradeId,
      description,
      modifiedBy,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteClass = async (id) => {
  try {
    const { data } = await axios.delete(`/api/v1/class?id=${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteClasses = async (classes) => {
  try {
    const { data } = await axios.post("/api/v1/class/school", classes);
    return data;
  } catch (error) {
    throw error;
  }
};
